module.exports = __webpack_public_path__ + "img/wxx.b83efa45.png";